import { GridChildComponentProps } from 'react-window';
import { TimeoutProps } from 'react-transition-group/Transition';

export interface VirtualItemProps
  extends GridChildComponentProps<undefined>,
    Partial<TimeoutProps<undefined>> {}
